import { VENDOR } from "../../types";

export const VendorReducer = (state, action) => {
  switch (action.type) {
    case VENDOR.STEPS:
      return {
        ...state,
        steps: action.payload,
      };
    case VENDOR.ACTIVE_STEP:
      return {
        ...state,
        activeStep: action.payload,
      };
    case VENDOR.VEND_FLOW_ENROLLMENT:
      return {
        ...state,
        vendFlowEnrollment: action.payload,
      };
    case VENDOR.VEND_INFORMATION:
      return {
        ...state,
        vendorInformation: action.payload,
      };
    case VENDOR.VEND_BANK_ACCOUNT:
      return {
        ...state,
        vendBankAccount: action.payload,
      };
    case VENDOR.COMPANY_INFORMATION:
      return {
        ...state,
        companyInformation: action.payload,
      };
    case VENDOR.VEND_DOCUMENTATION:
      return {
        ...state,
        vendDocumentation: action.payload,
      };
    case VENDOR.CONTACT_PERSON:
      return {
        ...state,
        contactPerson: action.payload,
      };
    case VENDOR.CONTACT_PERSON_BANK:
      return {
        ...state,
        contactPerson: action.payload,
      };
    case VENDOR.BANK_INFORMATION_LIST:
      return {
        ...state,
        bankInformationList: action.payload,
      };
    case VENDOR.LOGISTICS_POSTAL_ADDRESS:
      return {
        ...state,
        logisticsPostalAddress: action.payload,
      };
    case VENDOR.VEND_FULL_COMPANY:
      return {
        ...state,
        companyInformation: action.payload.company,
        vendDocumentation: action.payload.document,
        contactPerson: action.payload.contactPerson,
        listTypeContact: action.payload.listTypeContact,
        logisticsPostalAddress: action.payload.logisticsPostalAddress,
      };
    case VENDOR.VEND_FULL_BANK:
      return {
        ...state,
        vendBankAccount: action.payload.vendBankAccount,
        vendDocumentation: action.payload.document,
        contactPersonBank: action.payload.contactPersonBank,
        listTypeContact: action.payload.listTypeContact,
        logisticsPostalAddress: action.payload.logisticsPostalAddress,
      };
    case VENDOR.VEND_GENERAL_INFORMATION:
      return {
        ...state,
        vendGeneralInformation: action.payload,
      };
    case VENDOR.VEND_FULL_GENERAL_INFO:
      return {
        ...state,
        vendGeneralInformation: action.payload.vendGeneralInformation,
        companyOwner: action.payload.companyOwner,
        contractor: action.payload.contractor,
      };
    case VENDOR.COMPANY_OWNER:
      return {
        ...state,
        companyOwner: action.payload,
      };
    case VENDOR.CONTRACTOR:
      return {
        ...state,
        contractor: action.payload,
      };
    case VENDOR.VEND_ALL_INFO:
      return {
        ...state,
        vendorInformation: action.payload.vendorInformation,
        companyInformation: action.payload.companyInformation,
        contactPerson: action.payload.contactPerson,
        logisticsPostalAddress: action.payload.logisticsPostalAddress,
        vendBankAccount: action.payload.vendBankAccount,
        logisticsPostalAddressBank: action.payload.logisticsPostalAddressBank,
        contactPersonBank: action.payload.contactPersonBank,
        vendGeneralInformation: action.payload.vendGeneralInformation,
        companyOwner: action.payload.companyOwner,
        contractor: action.payload.contractor,
        listTypeContact: action.payload.respTypeContact,
      };
    case VENDOR.VEND_UPD_COMPANY_INFO:
      return {
        ...state,
        vendorInformation: action.payload.vendorInformation,
        companyInformation: action.payload.companyInformation,
        contactPerson: action.payload.contactPerson,
        logisticsPostalAddress: action.payload.logisticsPostalAddress,
        listTypeContact: action.payload.respTypeContact,
      };
    case VENDOR.VEND_UPD_GENERAL_INFO:
      return {
        ...state,
        vendorInformation: action.payload.vendorInformation,
        vendGeneralInformation: action.payload.vendGeneralInformation,
        companyOwner: action.payload.companyOwner,
        contractor: action.payload.contractor,
        listTypeContact: action.payload.respTypeContact,
      };
    case VENDOR.VEND_UPD_BANK_INFO:
      return {
        ...state,
        vendorInformation: action.payload.vendorInformation,
        bankInformationList: action.payload.bankInformationList,
        listTypeContact: action.payload.respTypeContact,
        listProvince: action.payload.listProvince,
        listBank: action.payload.listBank,
      };
    case VENDOR.VEND_UPD_DOCUMENTATION:
      return {
        ...state,
        vendorInformation: action.payload.vendorInformation,
        vendDocumentation: action.payload.vendDocumentation,
        companyInformation: action.payload.companyInformation,
      };
    case VENDOR.LIST_COUNTRY:
      return {
        ...state,
        listCountry: action.payload,
      };
    case VENDOR.LIST_PROVINCE:
      return {
        ...state,
        listProvince: action.payload,
      };
    case VENDOR.LIST_CITY:
      return {
        ...state,
        listCity: action.payload,
      };
    case VENDOR.LIST_BANK:
      return {
        ...state,
        listBank: action.payload,
      };
    case VENDOR.LIST_TYPE_CONTACT:
      return {
        ...state,
        listTypeContact: action.payload,
      };
    default:
      return state;
  }
};
